import React, { useEffect, useRef, useState } from "react";
import { Search, UserPlus, X } from "lucide-react";
import { api } from "@/lib/api";

// Autocomplete input yang mengambil data pelanggan dari database.
// onPick menerima objek pelanggan {name, phone, address}. Tetap bisa ketik manual.
export default function CustomerSearch({ value, onChangeName, onPick, placeholder = "Cari / ketik nama pelanggan", testid }) {
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    const q = (value || "").trim();
    if (q.length < 1) { setResults([]); return; }
    let alive = true;
    setLoading(true);
    const t = setTimeout(async () => {
      try {
        const list = await api.get("/customers", { q });
        if (alive) setResults(list.slice(0, 8));
      } catch { /* ignore */ } finally { if (alive) setLoading(false); }
    }, 300);
    return () => { alive = false; clearTimeout(t); };
  }, [value]);

  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  return (
    <div className="relative" ref={boxRef}>
      <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
      <input
        value={value}
        onChange={(e) => { onChangeName(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
        data-testid={testid}
        className="w-full h-10 pl-9 pr-8 rounded-xl border border-slate-300 text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/20"
      />
      {value ? (
        <button type="button" onClick={() => { onChangeName(""); setResults([]); }} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600">
          <X size={15} />
        </button>
      ) : null}
      {open && (value || "").trim().length >= 1 && (
        <div className="absolute z-30 left-0 right-0 mt-1 bg-white rounded-xl border border-slate-200 shadow-lg max-h-60 overflow-y-auto">
          {loading && <div className="px-3 py-2 text-xs text-slate-400">Mencari...</div>}
          {!loading && results.length === 0 && (
            <div className="px-3 py-2 text-xs text-slate-400 flex items-center gap-2"><UserPlus size={14} /> Pelanggan baru "{value}" akan dibuat otomatis</div>
          )}
          {results.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => { onPick(c); setOpen(false); }}
              data-testid={`customer-option-${c.id}`}
              className="w-full text-left px-3 py-2 hover:bg-primary/5 flex items-center justify-between gap-2"
            >
              <div className="min-w-0">
                <div className="text-sm font-medium text-slate-800 truncate">{c.name}</div>
                <div className="text-xs text-slate-400 truncate">{c.phone || "-"}{c.address ? ` · ${c.address}` : ""}</div>
              </div>
              {c.order_count ? <span className="text-xs text-slate-400 shrink-0">{c.order_count}x</span> : null}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
